<div id="<%= dom_id category %>">
  <p class="my-5">
    <strong class="block font-medium mb-1">Name:</strong>
    <%= category.name %>
  </p>

  <p class="my-5">
    <strong class="block font-medium mb-1">Order:</strong>
    <%= category.order %>
  </p>

  <p class="my-5">
    <strong class="block font-medium mb-1">Time:</strong>
    <%= category.time %>
  </p>

  <% if action_name != "show" %>
    <%= link_to "Show this category", category, class: "rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium" %>
    <%= link_to 'Edit this category', edit_category_path(category), class: "rounded-lg py-3 ml-2 px-5 bg-gray-100 inline-block font-medium" %>
    <hr class="mt-6">
  <% end %>
</div>
